import React from 'react';
import { Ontotis } from '../../../utils/types';
import { CONFIG } from '../../../utils/config';


interface OntotitesListProps {
  data: Ontotis[];
}

const OntotitesList: React.FC<OntotitesListProps> = ({ data }) => {
  
  return (
    <div>
      {data.map((item) => {

        return (
          <div className="card mb-4" key={item.id} data-title={item.title} data-budget={item.address}>
            <div className="card-body d-flex justify-content-between align-items-center">
              <div>
              <a href={CONFIG.urls.getOntotitaViewUrl_Admin(item.id!!)}  style={{ textDecoration: "none" }}>
                  <h5 className="card-title text-primary mb-1">{item.title}</h5>
                </a>
                <p className="mb-1 text-muted">
                  <strong></strong>{''}
                </p>
                <p className="mb-1 text-muted">
                  <>
                  </>
                </p>
              </div>
              <div>
            
                    <a className="btn btn-secondary btn-sm" href={CONFIG.urls.getOntotitaViewUrl_Admin(item.id!!)}>
                  <i className="bi bi-eye"></i> Προβολή
                </a>
             
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default OntotitesList;
